import {AbstractStep} from "./AbstractStep";
import {ISelection, IStepParams} from "./index";
import {Exceptions} from "./_def";
import {RuleMutable} from "./RuleMutable";
import step_2Html from './step-2.html?raw';

export let template = step_2Html;

export class viewModel extends AbstractStep {

    protected ruleMutable: RuleMutable = this.settings.ruleMutableException;

    constructor(params: IStepParams) {
        super(params);

        this.kosub.subscribe([
            this.settings.ruleMutableException.isActive,
            this.settings.exception,
            this.isValidRuleSelection,
        ] as KnockoutSubscribable<unknown>[], () => this.doValidation());

        this.ruleMutable.selection(Exceptions[0] ?? null)

        this.doValidation();
    }

    private getAvailableExceptions(): ISelection[] {
        const categoryValue = this.settings.category()?.value
        if (!categoryValue) {
            return []
        }
        return Exceptions
            .filter(s => s.category.includes(categoryValue))
    }

    protected validate(): boolean {
        const a = this.settings.ruleMutableException.isActive();
        const b = !!this.settings.exception();
        this.et.update(a && !b, this.settings.exception, '((invalid)) ((exception|ac))');
        const z = this.settings.ruleMutableException.isValid();
        return !a || b && z;
    }

}
